// extracted by mini-css-extract-plugin
module.exports = {"paymentViewBalance":"PaymentView-module_paymentViewBalance_1x4ie"};